import { Brand } from '../brand/brand.model';
import { ClosestEventsByType } from '../calendar/closestEventsByType';
import { Event } from '../calendar/event';
import { Channel } from '../channel/channel.model';
import { Dealer } from '../dealer/dealer.model';
import { User } from '../user/user.model';
import { LeadInput } from './leadInput';

export class Lead {
  id?: string;
  status?: string;
  onTrack?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;
  vat?: string;
  emailSubject?: string;
  type?: string;
  descriptionModel?: string;
  comments?: any;
  transferred?: boolean;
  assignedDate?: string;
  firstCallDate?: string;
  firstContactDate?: string;
  firstInteractionDate?: string;
  endDefeatDate?: number;
  callStartTime?: string;
  visitDate?: number;
  reminderDate?: number;
  pendingVisitDate?: number;
  failVisitDate?: number;
  origin?: string;
  createdAt?: number;
  updatedAt?: number;
  inCall?: boolean;
  inInteraction?: boolean;
  hasHtml?: boolean;
  tags?: string[];
  user?: User;
  brand?: Brand = new Brand();
  channel?: Channel = new Channel();
  dealer?: Dealer = new Dealer();
  closestEvent?: Event = new Event();
  closestEventsByType?: ClosestEventsByType = new ClosestEventsByType();
  concurrence?: number;
  alreadyCreated?: boolean;
  hasMessageId?: boolean;
  postalCode?: string;
  location?: string;
  address?: string;
  prequalification?: boolean;
  scoring?: number;
  sentToAutonet?: boolean;
  plate?: string;

  getLeadForm(): LeadInput {
    const leadform = new LeadInput();
    leadform.contactName = this.contactName;
    leadform.contactPhone = this.contactPhone;
    leadform.contactEmail = this.contactEmail;
    leadform.vat = this.vat;
    leadform.descriptionModel = this.descriptionModel;
    leadform.type = this.type;
    leadform.brand = this.brand;
    leadform.channel = this.channel;
    leadform.dealer = this.dealer;
    leadform.comments = this.comments;
    leadform.origin = this.origin;
    leadform.scoring = this.scoring;
    leadform.plate = this.plate;

    return leadform;
  }
}
